import React, { useState } from "react";
import { FoleonIcon, IconType } from "../icons/Icons";
import { Flex } from "@chakra-ui/react";
import { benchmarkCriteriaAtom } from "../../page/Dashboard";
import { useAtom } from "jotai";

type BookmarkProps = {
	publicationId: number;
	publicationTotalPages: number;
}

/**
 * Creates a bookmark component that can be added to a document card
 *
 * @constructor
 */
export const Bookmark = ( { publicationId, publicationTotalPages }: BookmarkProps) => {
	const [isHovering, setHovering] = useState(false);
	const [benchmarkCriteria] = useAtom(benchmarkCriteriaAtom);
	const HOVER_COLOUR = "#07C8E0";

	return (
		<>
			{
				<Flex
					position="absolute"
					right={0}
					top={0}
					zIndex="999"
					cursor="pointer"
					onMouseOver={() => setHovering(true)}
					onMouseLeave={() => setHovering(false)}
					onClick={() => {
						window.open(`/Analytics/${publicationId}/
						${benchmarkCriteria.avgUniqueVisitors}/
						${benchmarkCriteria.avgDocVisits}/
						${benchmarkCriteria.avgPagesPerVisit}/
						${benchmarkCriteria.avgVisitTime}/
						${publicationTotalPages}/`, "_blank");
					}}
				>
					<FoleonIcon
						iconType={IconType.BOOKMARK}
						color={isHovering ? HOVER_COLOUR : "grey"}
					/>
				</Flex>
			}
		</>
	);
};

export default Bookmark;
